export default "__VITE_ASSET__3bca9d7c__"